import * as React from 'react';
import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { ServiceLocator } from '../../ServiceLocator';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ConnectedRecentsSpace } from './ConnectedRecentsSpace';
import { RecentsSpaceOwnProps, RecentsSpaceProps } from './RecentsSpace';

export interface RecentsSpaceProviderProps extends ReactDirectiveProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

export interface RecentsSpaceAngularProps {
  readonly telemetry: Telemetry;
  readonly browserTitleService: BrowserTitleService;
}

const RecentsSpaceAngularHOC = angularProviderHOC<RecentsSpaceOwnProps, RecentsSpaceAngularProps, RecentsSpaceAngularProps>({
  getAngularServicesWithServiceLocator: () => ({
    telemetry: ServiceLocator.get<Telemetry>('TelemetryService'),
    browserTitleService: ServiceLocator.get<BrowserTitleService>('BrowserTitleService')
  }),
  selectPropsFromAngularServices: angularServices => angularServices,
});

const AngularWrappedConnectedRecentsSpace: React.ComponentType<RecentsSpaceOwnProps> = RecentsSpaceAngularHOC(ConnectedRecentsSpace);

const RecentsSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'recents',
  subspaceName: undefined
};

export const RecentsSpaceProvider: React.FunctionComponent<RecentsSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo= {RecentsSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <AngularWrappedConnectedRecentsSpace
          angularContext={props.angularContext}
          siteName={props.siteName}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
